import React from "react";
import axios from "axios";

const PaymentPopup = ({ onClose, onSubmit, event_id }) => {
  const [amount, setAmount] = React.useState("");

  const handleSubmit = async () => {
    if (amount.trim() === "") {
      alert("Please enter an amount");
      return;
    }
    // alert(1);
    onSubmit(amount, event_id);
  };

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-lg p-6 w-96">
        <h2 className="text-lg font-bold mb-4">Enter Payment Amount</h2>
        <input
          type="number"
          placeholder="Enter amount"
          className="w-full p-2 border rounded-lg mb-4"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
        />
        <div className="flex justify-end space-x-2">
          <button
            className="bg-gray-300 text-gray-700 px-4 py-2 rounded-lg hover:bg-gray-400"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700"
            onClick={handleSubmit}
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentPopup;
